<div class="elements-block" *ngFor="let item of filterList()">
  <div *ngIf="!loading" class="title" [ngClass]="font?.size" [innerHTML]="item.title | translate"></div>
  <ion-skeleton-text *ngIf="loading" class="skeleton-line" animated></ion-skeleton-text>
  <div class="icon i-download" (click)="downloadFile(item.url, item.title)"></div>
</div>
